<template>
  <div>
    <v-progress-linear
      v-if="loading"
      indeterminate
      color="blue"
    ></v-progress-linear>
    <v-layout row v-if="errors">
      <v-flex>
        <Alert @dismissed="onDismissed" :text="errors"></Alert>
      </v-flex>
    </v-layout>
    <v-form>
      <v-card class="pa-5 mb-5"   :style="{ border: '1px solid var(--primary-boarder-color)' }">
        <HeaderDividerBlock headerText="Company Details"></HeaderDividerBlock>
        <v-container class="pa-6">
          <v-row>
            <v-col cols="6" md="6">
              <v-text-field
                outlined
                dense
                v-model="form.company_name"
                :error-messages="this.fieldErrors.company_name"
                required
                label="Company Name"
                clearable
              ></v-text-field>
            </v-col>
            <v-col cols="6" md="6">
              <v-autocomplete
                v-model="form.company_type"
                :items="companyTypes"
                :error-messages="this.fieldErrors.company_type"
                dense
                outlined
                label="Company Type"
                clearable
                required
              ></v-autocomplete>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
      <v-card class="pa-5"   :style="{ border: '1px solid var(--primary-boarder-color)' }">
        <HeaderDividerBlock headerText="Contact Details"></HeaderDividerBlock>
        <v-container>
          <v-row>
            <v-col cols="6" md="4">
              <v-autocomplete
                v-model="form.title"
                :error-messages="this.fieldErrors.title"
                :items="titleList"
                dense
                outlined
                label="Title*"
                clearable
              ></v-autocomplete>
            </v-col>
            <v-col cols="6" md="4">
              <v-text-field
                outlined
                dense
                v-model="form.full_name"
                :error-messages="this.fieldErrors.full_name"
                required
                label="Full Name*"
              ></v-text-field>
            </v-col>
            <v-col cols="6" md="4">
              <v-text-field
                outlined
                dense
                v-model="form.job_title"
                :error-messages="this.fieldErrors.job_title"
                required
                label="Position"
              ></v-text-field>
            </v-col>
            <v-col cols="6" md="4">
              <v-text-field
                outlined
                dense
                v-model="form.phone"
                :error-messages="this.fieldErrors.phone"
                label="Phone"
              ></v-text-field>
            </v-col>
            <v-col cols="6" md="4">
              <v-text-field
                outlined
                dense
                v-model="form.mobile"
                label="Mobile*"
                :error-messages="this.fieldErrors.mobile"
              ></v-text-field>
            </v-col>
            <v-col cols="6" md="4">
              <v-text-field
                outlined
                dense
                v-model="form.email"
                :error-messages="this.fieldErrors.email"
                label="Email*"
              ></v-text-field>
            </v-col>
            <v-col cols="6" md="4">
              <v-text-field
                outlined
                dense
                v-model="form.address1"
                :error-messages="this.fieldErrors.address1"
                label="Address*"
              ></v-text-field>
            </v-col>

            <v-col cols="6" md="4">
              <v-text-field
                outlined
                dense
                v-model="form.city"
                :error-messages="this.fieldErrors.city"
                label="City*"
              ></v-text-field>
            </v-col>
            <v-col cols="6" md="4">
              <v-text-field
                outlined
                dense
                v-model="form.postal_code"
                :error-messages="this.fieldErrors.postal_code"
                label="Post Code"
              ></v-text-field>
            </v-col>
            <v-col cols="6" md="4">
              <v-autocomplete
                v-model="form.country"
                :items="countries"
                :error-messages="this.fieldErrors.country"
                label="Country*"
                dense
                outlined
                clearable
              ></v-autocomplete>
            </v-col>
            <v-col cols="6" md="4">
              <v-progress-linear
                v-if="loading2"
                indeterminate
                color="orange"
              ></v-progress-linear>
              <v-autocomplete
                v-model="form.state"
                :items="states"
                :error-messages="this.fieldErrors.state"
                label="State*"
                dense
                outlined
                clearable
              ></v-autocomplete>
            </v-col>
            <v-col cols="6" md="4">
              <FileUpload
                @changeFile="changeFile"
                :type="'image/*'"
                :error="this.fieldErrors.profile_image"
              />
              <v-col  v-if="imageUrl != 'null' ? true : false">
                <ImageBox :imageUrl="imageUrl" />
              </v-col>
            </v-col>
          </v-row>
        </v-container>
        <v-divider></v-divider>
        <v-card-actions>
          <v-row>
            <v-col cols="12" md="9" xs="6"> </v-col>
            <v-col cols="12" md="3" xs="6">
              <v-btn
                large
                color="#00B3FF"
                dark
                depressed
                :disabled="loading"
                block
                @click="update()"
                >Update</v-btn
              >
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
      <Snackbars
        :text="successMsg"
        :snackbar="snackbar"
        :color="'success'"
        @classSnackbar="closeSnackbar"
      />
      <Snackbars
        :text="'Validation error please scroll up'"
        :snackbar="snackbarError"
        :color="'red'"
        @classSnackbar="closeSnackbar"
      />
    </v-form>
  </div>
</template>

<script>
import Alert from "@/components/shared/Alert";
import { CustomerService } from "@/services/customer-service.js";
import { checkError } from "@/config/errors.js";
import Snackbars from "@/components/shared/Snackbars";
import FileUpload from "@/components/shared/FileUpload";
import ImageBox from "@/components/shared/ImageBox";
import HeaderDividerBlock from "@/components/shared/HeaderDividerBlock";

export default {
  name: "EditCustomer",
  components: { Alert, Snackbars, FileUpload, ImageBox, HeaderDividerBlock },

  data: () => ({
    role: localStorage.getItem("role") || null,
    imageUrl: "null",
    form: {
      title: "",
      full_name: "",
      company_name: "",
      job_title: "",
      phone: "",
      mobile: "",
      email: "",
      address1: "",
      city: "",
      state: "",
      postal_code: "",
      country: "",
      profile_image: null,
      company_type: "",
    },

    countries: [],
    states: [],
    snackbar: false,
    snackbarError: false,
    successMsg: "Customer has been updated successfully",
    errors: null,
    fieldErrors: [],
    loading: false,
    loading2: false,
    titleList: ["Mr", "Ms", "Miss", "Mrs", "Dr", "Prof", "Other"],
    companyTypes: ["Developer", "Consultant", "Contractor", "Other"],
    memberTypes: [],
    rolesList: [],
  }),

  watch: {
    "form.country": function(newCountry, oldCountry) {
      if (this.form.country !== null) {
        if (newCountry !== oldCountry) {
          this.getStates();
        }
      } else {
        this.form.state = "";
        this.states = [];
      }
    },
  },

  mounted() {
    if (this.$route.params.uuid) {
      this.onDismissed();
      this.getCustomerInfo();
      this.getCountries();
    }
  },

  methods: {
    update() {
      this.errors = null;
      this.loading = true;
      let fd = new FormData();

      fd.append("title", this.form.title ?? "");
      fd.append("full_name", this.form.full_name);
      fd.append("company_name", this.form.company_name ?? "");
      fd.append("job_title", this.form.job_title);
      fd.append("phone", this.form.phone);
      fd.append("mobile", this.form.mobile);
      fd.append("email", this.form.email);
      fd.append("address1", this.form.address1);
      fd.append("postal_code", this.form.postal_code);
      fd.append("city", this.form.city);
      fd.append("state", this.form.state ?? "");
      fd.append("country", this.form.country ?? "");
      fd.append("company_type", this.form.company_type ?? "");

      if (this.form.profile_image) {
        fd.append("profile_image", this.form.profile_image);
      }

      CustomerService.customerUpdate(this.$route.params.uuid, fd)
        .then((response) => {
          this.loading = false;
          if (response.data) {
            this.snackbar = true;
            this.snackbarError = false;
            this.$router.push("/customers");
          }
        })
        .catch((error) => {
          this.loading = false;
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.fieldErrors = data.errors;
          this.errors = errorOutput;
          window.scrollTo(0, 0);
        });
    },

    getCountries() {
      this.loading = true;
      CustomerService.getCountries()
        .then((response) => {
          this.loading = false;
          if (response.data) {
            this.countries = response.data.map((obj) => obj.name);
          }
        })
        .catch((error) => {
          this.loading = false;
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
        });
    },

    getStates() {
      this.loading2 = true;
      CustomerService.getStates(this.form.country)
        .then((response) => {
          this.loading2 = false;
          if (response.data) {
            this.states = response.data.map((obj) => obj.name);
          }
        })
        .catch((error) => {
          this.loading = false;
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
        });
    },

    changeFile(event) {
      if (event) {
        this.imageUrl = URL.createObjectURL(event);
        this.form.profile_image = event;
      } else {
        this.imageUrl = "null";
        this.form.profile_image = null;
      }
    },

    getCustomerInfo() {
      this.loading = true;
      CustomerService.getCustomerInfo(this.$route.params.uuid)
        .then((response) => {
          this.loading = false;
          if (response.data.data) {
            const customerData = response.data.data;
            this.setDefaultFormValues(customerData);
          }
        })
        .catch((error) => {
          this.loading = false;
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
        });
    },
    setDefaultFormValues(customerData) {
      this.form = {
        ...this.form,
        title: customerData.title || "",
        full_name: customerData.full_name || "",
        company_name: customerData.company_name || "",
        job_title: customerData.job_title || "",
        phone: customerData.phone || "",
        mobile: customerData.mobile || "",
        email: customerData.email || "",
        address1: customerData.address1 || "",
        postal_code: customerData.postal_code || "",
        city: customerData.city || "",
        state: customerData.state || "",
        country: customerData.country || "",
        company_type: customerData.company_type || "",
      };

      this.imageUrl = customerData.profile_image || "null";
    },

    closeSnackbar() {
      this.snackbar = false;
    },

    onDismissed() {
      this.errors = null;
    },

    reset() {
      this.form = [];
    },
  },
};
</script>
